import { isDevelopmentEnvironment } from "@/lib/env";

// Ligado: a funcionalidade só aparece fora de produção (localhost e homologação/DEV), usando a mesma
// verificação de ambiente do resto do sistema (@/lib/env). Desligue (false) para liberar em produção.
export const SCHEDULED_ORDER_CLIENT_VIEW_DEV_ONLY = true;

export let isScheduledOrderClientViewEnabled = false;

// Ajustes dos pedidos programados: cliente não vê avaliações/simulados na listagem, o texto
// "Aguardando composição" some e o detalhe do pedido não mostra as colunas Bonificada e Qtd. paga.
// Comente a linha abaixo para desativar os ajustes no frontend.
// Mantenha em sincronia com Features/ScheduledOrderClientViewFeature.cs do backend.
isScheduledOrderClientViewEnabled = !SCHEDULED_ORDER_CLIENT_VIEW_DEV_ONLY || isDevelopmentEnvironment;

// Avaliações e simulados na listagem do cliente: voltaram a ser exibidos (20/10). O texto "Aguardando composição" e as
// colunas Bonificada/Qtd. paga seguem controlados pela flag acima. Para ocultá-los de novo do cliente, descomente a
// linha abaixo (e a equivalente em Features/ScheduledOrderClientViewFeature.cs do backend, HidesEvaluations).
export let isScheduledOrderEvaluationsHiddenFromClient = false;
// isScheduledOrderEvaluationsHiddenFromClient = isScheduledOrderClientViewEnabled;
